import { routes } from "~/constants";
import { NextStep, NextStepProps } from "./constants";

export const getNextStep = ({
  attemptingRoute,
  onboarding,
  metaByPath,
  questionnaireOrder,
}: NextStepProps): NextStep => {
  const attemptingRouteIndex = questionnaireOrder.indexOf(attemptingRoute);

  for (let i = attemptingRouteIndex + 1; i < questionnaireOrder.length; i++) {
    const nextRouteConfig = metaByPath[questionnaireOrder[i]];

    if (nextRouteConfig.canRevisit(onboarding)) {
      return { route: questionnaireOrder[i], isExternal: false };
    }
  }

  return { route: routes.dashboard, isExternal: false };
};
